import { FC } from 'react';
import { useState, useRef, useEffect } from 'react';
import Link from 'next/link';
import styles from './PageHeadingSort.module.scss';

interface IPageHeadingSort {
  titleName: string;
  sortingName?: string;
  url?: string;
  extraClassName?: string;
  isPodcast?: boolean;
}

const PageHeadingSort: FC<IPageHeadingSort> = ({ titleName, sortingName, url, extraClassName, isPodcast }) => {
  const [isActive, setIsActive] = useState(false);

  const filtersName = isPodcast
    ? [
        { name: 'по рейтингу', url: '' },
        { name: 'по просмотрам', url: 'sorting/visited/' },
      ]
    : [
        { name: 'сначала новые', url: '' },
        { name: 'по рейтингу', url: 'sorting/rating/' },
        { name: 'по просмотрам', url: 'sorting/visited/' },
      ];

  if (url?.includes('avtor')) {
    filtersName.push({ name: 'по названию', url: 'sorting/nazvanie/' });
  }

  const refFilterMenu = useRef<HTMLUListElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: Event) => {
      if (refFilterMenu.current && refFilterMenu.current.contains(event.target as HTMLElement)) {
        return;
      }
      setIsActive(false);
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  });

  const handleToggleActiveClass = () => {
    setIsActive(!isActive);
  };

  return (
    <div className={extraClassName ? `${styles.pageHeading} ${styles[`${extraClassName}`]}` : `${styles.pageHeading}`}>
      <div className={`${styles.pageHeading__txt} ${styles.pageHeading__txt_sort}`}>
        <h1>{titleName}</h1>
      </div>
      {!!sortingName && (
        <div className={styles.pageHeading__sort}>
          <div className={styles.sort_wrap}>
            <div className={styles.sort_filter}>
              <div className={styles.sort_txt}>Сортировка</div>
              <ul onClick={handleToggleActiveClass} ref={refFilterMenu} className={`${styles.sort_list} ${isActive && styles.sort_list_active}`}>
                <li className={`${styles.sort_list_item} ${styles.sort_list_itemActive}`}>{sortingName}</li>

                {filtersName.map((btn) => (
                  <li key={btn.name} className={sortingName == btn.name ? `${styles.sort_list_item} ${styles.sort_list_itemNone}` : `${styles.sort_list_item}`}>
                    {sortingName === btn.name ? (
                      <span>{btn.name}</span>
                    ) : (
                      <Link prefetch={false} href={`${url}${btn.url}`}>
                        {btn.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PageHeadingSort;
